var map = {
	"./image-carousel.de-CH.json": 1382,
	"./image-carousel.de-DE.json": 1383,
	"./image-carousel.en-CA.json": 1384,
	"./image-carousel.en-GB.json": 1385,
	"./image-carousel.en-IN.json": 1386,
	"./image-carousel.en-ME.json": 1387,
	"./image-carousel.en-US.json": 1388,
	"./image-carousel.es-EM.json": 1389,
	"./image-carousel.es-ES.json": 1390,
	"./image-carousel.fr-BE.json": 1391,
	"./image-carousel.fr-CA.json": 1392,
	"./image-carousel.fr-CH.json": 1393,
	"./image-carousel.nl-BE.json": 1394,
	"./image-carousel.nl-NL.json": 1395,
	"./image-carousel.pl-PL.json": 1396,
	"./image-carousel.pt-BR.json": 1397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1381;